module.exports = __webpack_public_path__ + "static/media/lamp.ee58ee22.svg";